<template>
  <div class="x">
        <div class="y">
          <div></div>
          <div id="content-body">

            <div class="content-body-title">
              <div>{{date}}</div>
              <div>星期{{wdy[moment(date).weekday()]}}</div>
            </div>

            <div class="content-body-main">
              <slot></slot>
            </div>

          </div>
        </div>
      </div>
</template>

<script>
export default {
  props: ['date'],
  data () {
    return {
      wdy: ['日', '一', '二', '三', '四', '五', '六']
    }
  }

}
</script>

<style lang="scss" scoped>
.content-body-main {
  padding-block: 22px;
  flex: 1;
  height: -webkit-fill-available;
  overflow-y: auto;
  overflow-y: auto;
  max-height: calc(100vh - 336px);
  padding-inline: 10px;
}
.content-body-title {
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  letter-spacing: 0.1em;
  color: var(--color-pri);
}
#content-body {
  position: relative;
  padding-top: 50px;
  background-color: #FFFFFF;
  flex: 1;
  height: -webkit-fill-available;
  max-height: 100%;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 70px 1fr;
}
.y {
  background-color: #FFFFFF;
  flex: 1;
  height: calc(100% - 30px);
  margin-top: 45px;
  border-radius: 10px;
  padding-inline: 12px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  &::before {
    content: '';
    width: 90px;
    height: 90px;
    background-color: #FFFFFF;
    position: absolute;
    top: -45px;
    left: 50%;
    transform: translateX(-45px);
    border-radius: 45px;
    z-index: 3;
  }
  &>div:nth-child(1){
      width: 71px;
      height: 71px;
      background-color: var(--color-pri);
      position: absolute;
      top: -35.5px;
      left: 50%;
      transform: translateX(-35.5px);
      border-radius: 45px;
      background-image: url(/calendarv2w.svg);
      background-position: center;
      background-size: 33px;
      background-repeat: no-repeat;
      z-index: 3;
  }
}
.x {
  // background-color: #DADADA;
  height: -webkit-fill-available;
  flex: 1;
  position: relative;
  padding: 5px;
  padding-top: 0;
  &::before {
    content: '';
    width: 90px;
    height: 90px;
    background-color: #FFFFFF;
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-45px);
    border-radius: 45px;
    z-index: 1;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  }
}
</style>
